var HttpStatus;
(function (HttpStatus) {
    HttpStatus[HttpStatus["Conflict"] = 409] = "Conflict";
})(HttpStatus || (HttpStatus = {}));
export default HttpStatus;
//# sourceMappingURL=HttpStatus.js.map